$ = jQuery;

function initContactButton() {
  $(".contact-section").addClass("closed");
  $(".cta-link").addClass("closed");

  $(".footer-contact .cta-link").click(function () {
    if ($(".footer-contact .contact-section").hasClass("closed")) {
      $(".footer-contact .contact-section").removeClass("closed");
      $(".footer-contact .cta-link").removeClass("closed");
    } else {
      $(".footer-contact .contact-section").addClass("closed");
      $(".footer-contact .cta-link").addClass("closed");
    }
  });
  $(".footer-staff .cta-link").click(function () {
    if ($(".footer-staff .contact-section").hasClass("closed")) {
      $(".footer-staff .contact-section").removeClass("closed");
      $(".footer-staff .cta-link").removeClass("closed");
    } else {
      $(".footer-staff .contact-section").addClass("closed");
      $(".footer-staff .cta-link").addClass("closed");
    }
  });
  $(".page-id-17 .footer-contact .contact-section").removeClass("closed");
  $(".page-id-17 .footer-contact .cta-link").removeClass("closed");
}

function carousel() {
  $(".portfolio-carousel").slick({
    centerMode: true,
    centerPadding: "60px",
    slidesToShow: 4,
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    pauseOnDotsHover: true,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1100,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "40px",
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "40px",
          slidesToShow: 1,
        },
      },
    ],
  });
}

function slider() {
  $(".slider").slick({
    arrows: true,
    infinite: true,
    prevArrow:
      '<button class="prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="27" viewBox="0 0 27 54"><path fill="#d3313a" d="M27 0 0 27l27 27V42.254L11.746 27 27 11.746Z" data-name="Path 10450"/></svg></button>',
    nextArrow:
      '<button class="next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="27" viewBox="0 0 27 54"><path fill="#d3313a" d="m0 54 27-27L0 0v11.746L15.254 27 0 42.254Z" data-name="Path 10451"/></svg></button>',
  });
}

function watchCheckBoxes() {
  const selector = "main.site-main form.filters";
  const form = document.querySelector(selector);

  if (!form) return;

  $(form.querySelectorAll("input")).on("click", function (event) {
    $(form).submit();
  });
}

function locationNav() {
  $(".location-nav a").each(function () {
    var linkURL = $(this).attr("href");
    var currentURL = window.location.pathname;

    if (linkURL && linkURL.startsWith(window.location.origin)) {
      linkURL = linkURL.substring(window.location.origin.length);
    }
    console.log(linkURL);
    console.log(currentURL);

    if (linkURL === currentURL) {
      $(this).addClass("active");
    }
  });
}

import anime from "animejs/lib/anime.es.js";

function prepAnimatedPieces() {
  const piecesToPrep = document.querySelectorAll(
    ".cta-text-contain, .wp-block-column, .contact-form, .split-info",
  );
  piecesToPrep.forEach(function (piece) {
    piece.classList.remove("animated");
    piece.querySelectorAll("h2, h4, p, div").forEach(function (piece) {
      piece.style.opacity = 0;
    });
  });
}

function animatedPieces() {
  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (
          entry.isIntersecting &&
          !entry.target.classList.contains("animated")
        ) {
          console.log("whatever", entry.target);

          anime({
            targets: entry.target.querySelectorAll("h2, h4, p, div"),
            opacity: [0, 1],
            translateY: [-100, 0],
            easing: "easeInOutQuint",
            duration: 1000,
          });

          anime({
            targets: entry.target.querySelectorAll(".split-info__left"),
            opacity: [0, 1],
            translateY: [-100, 0],
            easing: "easeInOutQuint",
            duration: 1000,
          });

          anime({
            targets: entry.target.querySelectorAll(".split-info__right"),
            opacity: [0, 1],
            translateY: [-100, 0],
            easing: "easeInOutQuint",
            duration: 1500,
          });

          entry.target.classList.add("animated");
        }
      });
    },
    {
      rootMargin: "0% 0% -30% 0%",
    },
  );

  const piecesToWatch = document.querySelectorAll(
    ".cta-text-contain, .wp-block-column, .contact-form, .split-info",
  );

  piecesToWatch.forEach(function (piece) {
    observer.observe(piece);
  });
}

// prepAnimatedPieces();
$(document).ready(function () {
  // animatedPieces();
  locationNav();
  initContactButton();
  carousel();
  slider();
  watchCheckBoxes();
});
